/** @deprecated Ruta deshabilitada — ver `../legacy/README.md`. */
import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import { ToastContainer } from 'react-toastify';
import GuideDetailsList from './GuideDetailsList';

const GuideDetails = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '#', label: 'Medio Ambiente' },
		{ to: '/residue/dashboard', label: 'Residuos' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Detalle de Guías' links={breadcrumbLinks} />
					<GuideDetailsList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default GuideDetails;
